import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IContactState } from './store/contact.state';
import { getContactSelectors } from './store/contact.selectors';
import { Store } from '@ngrx/store';
import { setContactAction } from './store/contact.actions';
import { getCookie } from 'src/app/utils/get-cookie';
import { RecomendationsService } from 'src/app/services/recomendations.service';
import { IRecomendations } from 'src/app/modules/interfaces/recomendations.interface';

@Component({
  selector: 'app-end-of-collection',
  templateUrl: './end-of-collection.component.html',
  styleUrls: ['./end-of-collection.component.scss'],
})
export class EndOfCollectionComponent implements OnInit {
  
  formsId: number;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IContactState>;
  dataState: IContactState = {
    check: false,
    listContacts: [],
  };

  recomendationsData: IRecomendations[] = []
  dataLocal: IContactState = { ...this.dataState };

  constructor(private store: Store, private recomendationsService: RecomendationsService) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadingRecomendations()
  }

  loadingRecomendations(){
    this.recomendationsService.getRecomendationsData(this.formsId).subscribe((response)=>{
      if (response.data.length === 0) {
        this.addContactWithDelay();
      } else {
        this.recomendationsData = response.data
      }
      this.saveState()
    })
  }

  getState(): void {
    this.dataState$ = this.store.select(getContactSelectors);
    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...value,
      };
    });
  }

  setState(data: IContactState): void {
    this.store.dispatch(setContactAction(data));
  }

  updateContact(data: any, index: number): void {
   
    if (this.isValidIndex(index)) {
      const updatedListContacts = [...this.recomendationsData];
      updatedListContacts[index] = { ...data };
      this.dataState.listContacts = updatedListContacts;
      this.setState(this.dataState);
      this.recomendationsData = this.dataState.listContacts
    
    }
  }

  saveForm(){
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    this.recomendationsService.createRecomendations(this.formsId, this.recomendationsData ).subscribe({
      next: () => {
        this.isSaving = false;
        this.saveButtonText = 'Salvo';
        this.saveButtonClass = 'btn-primary';
        this.saveState()
      },
      error: (err) => {
        this.isSaving = false;
        this.saveButtonText = 'Erro ao salvar';
        this.saveButtonClass = 'btn-danger';
        console.error('Erro ao atualizar os dados do seguro', err);
      },
    })
  }

  saveState(){
    this.dataState = {
      ...this.dataState,
      check: this.recomendationsData.length > 0,
      listContacts: this.recomendationsData.map(contact => ({
        name: contact.name,
        email: contact.email,
        phone: contact.phone,
        notes: contact.notes,
      })),
    };

    this.setState(this.dataState);
  }

  addContactWithDelay(): void {
    setTimeout(() => {
      this.addContact();
    }, 1000);
  }

  addContact(): void {
    if (!Array.isArray(this.dataState.listContacts)) {
      this.dataState.listContacts = [];
    }
    const newContact = {
      name: '',
      email: '',
      phone: '',
      notes: '',
    };

    this.dataState.listContacts = [...this.dataState.listContacts, newContact];
    this.setState(this.dataState);
    this.dataLocal = { ...this.dataState };
    this.recomendationsData = [...this.dataState.listContacts]
    
  }

  deleteContact(index: number): void {
    if (this.isValidIndex(index)) {
      const updatedListContacts = [...this.dataState.listContacts];
      updatedListContacts.splice(index, 1);
      this.dataState.listContacts = updatedListContacts;
      this.setState(this.dataState);
      this.dataLocal = { ...this.dataState };
      this.recomendationsData = [...this.dataState.listContacts]
    }
  }

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.recomendationsData.length;
  }
}
